<template>
  <div id="app">
    <el-container class="app-container">

      <el-header class="app-header">
        <Header />
      </el-header>

      <el-main class="app-main">
        <router-view/>
      </el-main>

      <el-footer class="app-footer">
        <Footer />
      </el-footer>

    </el-container>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}
*{
  color: #2c3e50;
}
#app {
  font-family: 'Inter', 'Noto Sans JP', sans-serif;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-header, .app-footer {
  flex-shrink: 0;
}
.el-header{
  padding: 0 !important;
}
.el-footer{
  height: auto !important;
  padding: 0 !important;
}
.app-main {
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
}
</style>
